// assets
import { DashboardOutlined } from '@ant-design/icons';
import { HomeOutlined } from '@ant-design/icons';
import { ShopOutlined } from '@ant-design/icons';
import { DollarOutlined } from '@ant-design/icons';
import { SnippetsOutlined } from '@ant-design/icons';
import { HeartOutlined } from '@ant-design/icons';

// icons
const icons = {
    DashboardOutlined,
    HomeOutlined,
    ShopOutlined,
    DollarOutlined,
    SnippetsOutlined,
    HeartOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'group-dashboard',
    title: null,
    type: 'protected',
    children: [
        {
            id: 'bidding',
            title: 'Auctions',
            type: 'item',
            url: '/dash/bidding',
            icon: icons.ShopOutlined,
            breadcrumbs: false,
        },
        {
            id: 'buynow',
            title: 'Buy Now',
            type: 'item',
            url: '/dash/buynow',
            icon: icons.DollarOutlined,
            breadcrumbs: false,
        },
        {
            id: 'mybids',
            title: 'My Bids',
            type: 'item',
            url: '/dash/mybids',
            icon: icons.SnippetsOutlined,
            breadcrumbs: false,
        },
        {
            id: 'favourite',
            title: 'My Favourites',
            type: 'item',
            url: '/dash/favourite',
            icon: icons.HeartOutlined,
            breadcrumbs: false,
        }
    ],
};

export default dashboard;
